import {
	type DataFromGarment,
	fromGarment,
} from 'maps/services/dto/fromGarment'
import type { Store } from 'maps/types'
import { ENDPOINT_STORES_GARMENTS } from 'maps/utils/constants'
import { fetcher } from 'services/rest/fetcher'
import { env } from 'utils/envManager'

export type GetStoresFromGarmentParams = {
	productId: string
	colorId: string
	brand: string
	country: string
	language: string
	latitude?: string
	longitude?: string
	radiusFilter?: boolean
}

export async function getStoresFromGarment({
	productId,
	colorId,
	brand,
	country,
	language,
	...restOfProps
}: GetStoresFromGarmentParams): Promise<Store[]> {
	const url = new URL(
		`${ENDPOINT_STORES_GARMENTS}/${productId}`,
		env.NEXT_PUBLIC_SITE_BASE_URL
	)

	const radiusFilter = restOfProps?.radiusFilter || false

	url.search = new URLSearchParams({
		brand,
		product: productId,
		color: colorId,
		country: country.toUpperCase(),
		language: language.toUpperCase(),
		channel: env.NEXT_PUBLIC_CHANNEL,
		latitude: restOfProps?.latitude || '0.0',
		longitude: restOfProps?.longitude || '0.0',
		radiusFilter: radiusFilter.toString(),
	}).toString()

	const { stores } = await fetcher<{ stores: DataFromGarment[] }>(url.href)

	return stores.map(fromGarment)
}
